import MultiselectCell from '../../components/table/cell-types/multiselect-cell.vue.js';

var script = {
  name: 'PendoGuideCategoryInlineMultiselect',
  components: {
    MultiselectCell
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedGuideCategory: {
      type: Object,
      default: null
    },
    emptyOption: {
      type: Object,
      default: null
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-category-inline-multiselect.vue2.js.map
